export const SITE_URL = "https://www.davidemagnoni.it";
export const SITE_TITLE = "Davide Magnoni | Frontend and Creative Developer";
export const SITE_DESCRIPTION = "Davide Magnoni is a frontend and creative developer building expressive interfaces through motion, code, and three-dimensional space.";

// The contact form ships in stand-by: the panel renders read-only and no submission is possible.
// Set this to true once the mail provider is connected and `RESEND_API_KEY` plus
// `CONTACT_TO_EMAIL` are set in Vercel. See docs/contact-form-setup.md.
export const CONTACT_FORM_ENABLED: boolean = false;

interface SocialLink {
  label: string;
  href: string;
  icon: string;
  download?: boolean;
}

export const SOCIAL_LINKS: readonly SocialLink[] = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/davide-magnoni/",
    icon: "/icons/social/dm_linkedin.svg",
  },
  {
    label: "Curriculum vitae",
    href: "/cv-2026-single-column.pdf",
    icon: "/icons/social/dm_cv.svg",
    download: false,
  },
  {
    label: "CodePen",
    href: "https://codepen.io/maghno",
    icon: "/icons/social/dm_codepen.svg",
  },
  {
    label: "GitHub",
    href: "https://github.com/Magno95",
    icon: "/icons/social/dm_github.svg",
  },
];
